import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/app/src/app/professionals/faq/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedPage"] */ "/app/src/components/AnimatedPage.tsx");
